@if (solution(); as s) {
  <section class="sold">
    <!-- ===== Hero oscuro ===== -->
    <div class="sold__hero">
      <div class="sold__wrap sold__hero-grid">
        <div class="sold__hero-text">
          <nav class="sold__crumb">
            <a routerLink="/soluciones">Soluciones</a>
            <span class="sold__crumb-sep">/</span>
            <span class="sold__crumb-here">{{ s.sector }}</span>
          </nav>
          <h1 class="sold__title">{{ s.heroTitle }}</h1>
          <p class="sold__subtitle">{{ s.heroSubtitle }}</p>
          <div class="sold__hero-cta">
            <a
              class="ts-btn ts-btn--primary ts-btn--lg"
              routerLink="/prueba-sin-compromiso"
              [queryParams]="{ sol: s.slug }"
              >Empieza la prueba con esta selección</a
            >
            <a class="sold__hero-link" routerLink="/contacto">Cuéntanos tu caso</a>
          </div>
          <span class="sold__hero-fine"
            >14 días · sin tarjeta ni permanencia · te lo montamos si quieres</span
          >
        </div>
        <div class="sold__hero-media">
          <app-image-slot
            [src]="img(s, 'hero')"
            [hint]="s.heroImageHint"
            [brandColor]="brandColor(s)"
            [minHeight]="360" />
        </div>
      </div>
    </div>

    <!-- ===== Desglose ===== -->
    <div class="sold__breakdown">
      <div class="sold__wrap">
        <h2 class="sold__h2">Lo que trae preseleccionado</h2>
        <p class="sold__h2-sub">
          Los mismos módulos del catálogo, a los mismos precios. En la prueba
          puedes quitar o añadir cualquiera.
        </p>

        <div class="sold__cards">
          <!-- Base Esencial -->
          <div class="sold-card sold-card--base">
            <div class="sold-card__head">
              <span class="sold-card__name">
                <app-ts-piece piece="full" color="var(--ts-primary)" [size]="24" />
                {{ base.label }}
              </span>
              <span class="sold-card__price">{{ base.price }} €/mes</span>
            </div>
            <span class="sold-card__desc">{{ base.desc }}</span>
            <span class="sold-card__note">{{ base.note }}</span>
          </div>

          <!-- Módulos preseleccionados -->
          @for (m of s.modules; track m.label) {
            <div class="sold-card">
              <div class="sold-card__head">
                <span class="sold-card__name">
                  <app-ts-piece piece="tr" [color]="m.color" [size]="22" />
                  {{ m.label }}
                </span>
                <span class="sold-card__price">+{{ m.price }} €/mes</span>
              </div>
              <span class="sold-card__desc">{{ m.desc }}</span>
              @if (m.complement) {
                <span class="sold-card__addon">
                  <span class="sold-card__addon-name">
                    <app-ts-piece
                      piece="tr"
                      variant="outline"
                      [color]="m.complement.color"
                      [size]="18" />
                    Complemento: {{ m.complement.label }}
                  </span>
                  <span class="sold-card__addon-price">+{{ m.complement.price }} €/mes</span>
                </span>
                <span class="sold-card__addon-desc">{{ m.complement.desc }}</span>
              }
            </div>
          }
        </div>

        <div class="sold__total">
          <span class="sold__total-detail">{{ breakdown(s) }}</span>
          <span class="sold__total-amount"
            >{{ total(s) }} €/mes
            <span class="sold__total-fine">· IVA no incl. · sin permanencia</span></span
          >
        </div>
      </div>
    </div>

    <!-- ===== Día a día ===== -->
    <div class="sold__day">
      <div class="sold__wrap">
        <h2 class="sold__h2">Un día con la solución aplicada</h2>
        <div class="sold__timeline">
          @for (step of s.timeline; track step.title) {
            <div class="sold-step">
              <span class="sold-step__time">{{ step.time }}</span>
              <span class="sold-step__title">{{ step.title }}</span>
              <span class="sold-step__text">{{ step.text }}</span>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- ===== Ejemplo de uso ===== -->
    <div class="sold__wrap sold__case">
      <app-image-slot
        class="sold__case-img"
        [src]="img(s, 'caso')"
        [hint]="s.case.imageHint"
        [brandColor]="brandColor(s)"
        [minHeight]="300" />
      <div class="sold__case-text">
        <span class="sold__case-eyebrow">Ejemplo de uso</span>
        <span class="sold__case-title">{{ s.case.title }}</span>
        <span class="sold__case-body">{{ s.case.text }}</span>
        @if (s.case.caseSlug) {
          <span class="sold__case-link">
            <a [routerLink]="['/a-medida', s.case.caseSlug]">Ver el caso completo →</a>
          </span>
        }
        @if (s.case.tags) {
          <span class="sold__case-tags">{{ s.case.tags }}</span>
        }
      </div>
    </div>

    <!-- ===== CTA final ===== -->
    <div class="sold__cta">
      <div class="sold__wrap sold__cta-inner">
        <h2 class="sold__cta-title">{{ s.ctaTitle }}</h2>
        <p class="sold__cta-text">{{ ctaText }}</p>
        <div class="sold__cta-actions">
          <a
            class="ts-btn ts-btn--primary ts-btn--lg"
            routerLink="/prueba-sin-compromiso"
            [queryParams]="{ sol: s.slug }"
            >Empieza la prueba con esta selección</a
          >
          <span class="sold__cta-fine">14 días · sin tarjeta ni permanencia</span>
        </div>
      </div>
    </div>
  </section>
} @else {
  <section class="sold sold--notfound">
    <div class="sold__wrap">
      <h1 class="sold__nf-title">Solución no encontrada</h1>
      <p>La página que buscas no existe o aún no está disponible.</p>
      <a class="ts-btn ts-btn--primary" routerLink="/soluciones">Ver todas las soluciones</a>
    </div>
  </section>
}
